// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Services.module.css';

import MoreDropDown from './MoreDropDown';
import PaymentLinkPopup from './PaymentLinkPopup/PaymentLinkPopup';
import { AnimatePresence } from 'framer-motion';

export default function TableRow({ value, index }) {

  const [openPaymentLink, setopenPaymentLink] = useState(false);
  const handleopenPaymentLink = () => {
    setopenPaymentLink(true);
  }
  const handleClosePaymentLink = () => {
    setopenPaymentLink(false);
  }

  return (
    <>
      {/* Desktop view */}
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={value._id}
      >
        {/* Name/Email */}
        <div className={`${Classes.customerInfo} ${Classes.colCustomer}`}>
          <input type='checkbox' />
          {/* <span className={Classes.tableHeadName}>
            <h5 className="truncate">value.name</h5>
          </span> */}
        </div>
        {/* Spend */}
        <div className={`${Classes.spendings} ${Classes.colSpendings}`}>
          <h5>{value.service}</h5>
        </div>
        {/* Bookings */}
        <div className={`${Classes.bookings} ${Classes.colBookings}`}>
          <h5>{value.price}</h5>
        </div>
        {/* Date Joined */}
        <div className={`${Classes.dateJoined} ${Classes.colDate}`}>
          <h5>{value.created}</h5>
        </div>
        {/* Disable toggle */}
        <div className={`${Classes.disableToggle} ${Classes.colDisable}`}>
          <h5>{value.updated}</h5>
        </div>
        {/* Actions */}
        <div className={`${Classes.actions} ${Classes.colActions}`}>
          <MoreDropDown
            index={index}
            user={value}
            handleopenPaymentLink={handleopenPaymentLink}
          />
        </div>
      </div>

      <AnimatePresence>
        {openPaymentLink && <PaymentLinkPopup handleClose={handleClosePaymentLink} />}
      </AnimatePresence>
    </>
  );
}
